import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// form
import { useForm, } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui
import { LoadingButton } from '@mui/lab';
import { Box, Card, Grid, Stack, } from '@mui/material';
// routes
import { PATH_MASTERDATA } from '../../../routes/paths';
import { useSnackbar } from '../../../components/snackbar';
import FormProvider, {
  RHFAutocomplete,
  RHFSwitch,
  RHFTextField,
} from '../../../components/hook-form';
import userAPI from 'src/api/userAPI';
import siteAPI from 'src/api/siteAPI';
import { fetchAllData } from 'src/api/fetchAll';

// ----------------------------------------------------------------------

UserNewEditForm.propTypes = {
  isEdit: PropTypes.bool,
  currentUser: PropTypes.object,
};

export default function UserNewEditForm({ isEdit = false, currentUser }) {
  const navigate = useNavigate();

  const { enqueueSnackbar } = useSnackbar();

  const NewUserSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    nik: Yup.string().required('NIK is required').max(16, 'NIK must be exactly 16 characters'),
    // email: Yup.string().email('Invalid email'),
    phone: Yup.string().max(20, 'Phone must be at most 20 characters'),
    // role_id: Yup.number().required('Role is required'),
    site_id: Yup.number().required('Site is required'),
    is_fraud: Yup.boolean(),
    is_active: Yup.boolean(),
    address: Yup.string(),
    // password: Yup.string().when([], {
    //   is: () => !isEdit,
    //   then: (schema) =>
    //     schema.required('Password is required').min(8, 'Password must be at least 8 characters'),
    //   otherwise: (schema) => schema.notRequired(),
    // }),
    // confirmPassword: Yup.string().when('password', {
    //   is: (val) => !!val && !isEdit,
    //   then: (schema) =>
    //     schema
    //       .oneOf([Yup.ref('password')], 'Passwords must match')
    //       .required('Please confirm your password'),
    //   otherwise: (schema) => schema.notRequired(),
    // }),
  });


  const defaultValues = useMemo(
    () => ({
      name: currentUser?.name || '',
      nik: currentUser?.nik || '',
      // email: currentUser?.email || '',
      // password: '',
      // confirmPassword: '',
      phone: currentUser?.phone || '',
      // role_id: currentUser?.role_id || '',
      site_id: currentUser?.site_id || '',
      is_fraud: currentUser?.is_fraud || 0,
      is_active: currentUser?.is_active || 0,
      address: currentUser?.address || '',
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentUser]
  );

  const methods = useForm({
    resolver: yupResolver(NewUserSchema),
    defaultValues,
  });

  const {
    reset,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;


  useEffect(() => {
    if (isEdit && currentUser) {
      reset(defaultValues);
    }
    if (!isEdit) {
      reset(defaultValues);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEdit, currentUser]);

  const [sites, setSites] = useState([]);
  const [loadingSite, setLoadingSite] = useState(false);

  useEffect(() => {
    const fetchSites = async () => {
      setLoadingSite(true);
      try {
        // const res = await siteAPI.getActiveSites();
        const res = await fetchAllData(siteAPI.getActiveSites, 100, { is_active: 1 });
        setSites(res || []);
      } catch (error) {
        console.error('Failed to load sites', error);
      } finally {
        setLoadingSite(false);
      }
    };
    fetchSites();
  }, []);

  const onSubmit = async (data) => {
    // return;
    const payload = {
      ...data,
      role_id: 3,
      site_id: data.site_id ? Number(data.site_id) : null,
      is_active: true,
    };
    delete payload.confirmPassword;

    try {
      if (isEdit) {
        await userAPI.updateUser(currentUser.id, payload);
        enqueueSnackbar('User updated successfully!');
      }
      // Jika create, buat user baru
      else {
        await userAPI.createUser(payload);
        enqueueSnackbar('User created successfully!');
      }

      reset();
      navigate(PATH_MASTERDATA.user);
    } catch (error) {
      console.error(error);
      enqueueSnackbar(error?.response?.data?.message || 'Failed to save user', { variant: 'error' });
    }
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={3} >
        <Grid item xs={12} md={10}>
          <Card sx={{ p: 3 }}>
            <Box
              rowGap={3}
              columnGap={2}
              display="grid"
              gridTemplateColumns={{
                xs: 'repeat(1, 1fr)',
                sm: 'repeat(2, 1fr)',
              }}
            >
              <RHFTextField name="name" label="Name" />
              <RHFTextField name="nik" label="NIK" />
              {/* <RHFTextField name="email" label="Email Address" /> */}
              <RHFTextField name="phone" label="Phone Number" />
              {/* {!isEdit ?
                <>
                  <RHFTextField name="password" label="Password" type="password" />
                  <RHFTextField name="confirmPassword" label="Confirm Password" type="password" />
                </>
                : null} */}

              {/* <RHFAutocomplete
                name="role_id"
                label="Role"
                options={roles}
                getOptionLabel={(option) => option.name}
              /> */}

              <RHFAutocomplete
                name="site_id"
                label="Site"
                options={sites}
                getOptionLabel={(option) => option.name}
                loading={loadingSite}
              />

              <RHFTextField name="address" label="Address" />

              {/* <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ width: '100%' }}>
                {isEdit && <RHFSwitch name="is_fraud" label="Fraudulent User" />}
                <RHFSwitch name="is_active" label="Active User" />
              </Stack> */}
            </Box>

            <Stack alignItems="flex-end" sx={{ mt: 3 }}>
              <LoadingButton type="submit" variant="contained" loading={isSubmitting}>
                {!isEdit ? 'Create Courier' : 'Save Changes'}
              </LoadingButton>
            </Stack>
          </Card>
        </Grid>
      </Grid>
    </FormProvider>
  );
}
